import { useContext } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import api from '../../../../api/api.js';
import { isDemo, AppContext, WidgetsContext } from '../../../GlobalContex';
import useNotifications from '../../../hooks/useNotifications';
import { useAnalytics } from '../../../hooks/useAnalytics';

const VimeoConnectButton = () => {
  const { t } = useTranslation();
  const notification = useNotifications();
  const { setIsLoading, isEmbeded } = useContext(AppContext);
  const { activeWidget, setActiveWidgetSettings, activeWidgetMeta } = useContext(WidgetsContext);

  const connectVimeo = async() => {
    setIsLoading(true)
    try {
      const payload = await api.connectVimeo(
        activeWidgetMeta.connectPageUrl || `apps/vimeo-feed/widgets/${activeWidget.id}/data`,
        { preview: isDemo, withTracking: isEmbeded() }
      )
      setActiveWidgetSettings(payload);
    } catch(err) {
      notification.error(err.message)
    }
    setIsLoading(false)
  }

  if (activeWidget?.settings?.account) {
    return (
      <>
        <Form.Group className={'mb-3'}>
          <Button style={{ width: '100%', margin: '0' }} onClick={connectVimeo}>
            {t('Change Vimeo Account')}
          </Button>
        </Form.Group>
        <Form.Group>{t('Connected Vimeo Account')}: {activeWidget?.settings?.account?.name}</Form.Group>
      </>
    );
  } else {
    return (
      <>
        <Form.Group className={'mb-3'}>
          <Button style={{ width: '100%', margin: '0' }} onClick={connectVimeo}>
            {t('Connect Vimeo Account')}
          </Button>
        </Form.Group>
      </>
    );
  }
};

export default VimeoConnectButton;
